import Service from "../Service";

const resource = "ManagementPrice/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    getById(mgpID, requestID) {
        return Service.post(resource + "getbyid?mgpID=" + mgpID, { mgpID }, {
            params: { requestID: requestID, mgpID: mgpID },
        });
    },

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
};
